import Storage from '@deezer/storage';

export const DZR_UNIQ_ID_STORAGE_KEY = 'dzr_uniq_id';

const GENERATED_UUID_V4_PATTERN =
	/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const DEEZER_DZR_UNIQ_ID_PATTERN = /^[A-Za-z0-9._-]{8,128}$/;

const getStorage = (): Storage | null => {
	if (typeof window === 'undefined') {
		return null;
	}
	return new Storage();
};

const isDzrUniqId = (value: string): boolean =>
	GENERATED_UUID_V4_PATTERN.test(value) ||
	DEEZER_DZR_UNIQ_ID_PATTERN.test(value);

const getCookieValue = (key: string): string | null => {
	const cookie = document.cookie
		.split('; ')
		.find((entry) => entry.startsWith(`${key}=`));

	if (!cookie) {
		return null;
	}

	return decodeURIComponent(cookie.slice(key.length + 1));
};

const generateUuidV4 = (): string => {
	if (typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}

	const bytes = new Uint8Array(16);
	crypto.getRandomValues(bytes);
	bytes[6] = (bytes[6] & 0x0f) | 0x40;
	bytes[8] = (bytes[8] & 0x3f) | 0x80;

	const hex = Array.from(bytes, (byte) =>
		byte.toString(16).padStart(2, '0'),
	).join('');

	return [
		hex.slice(0, 8),
		hex.slice(8, 12),
		hex.slice(12, 16),
		hex.slice(16, 20),
		hex.slice(20),
	].join('-');
};

export const getOrCreateDzrUniqId = (): string | null => {
	const storage = getStorage();
	if (!storage) {
		return null;
	}

	const existing = storage.get<string>(DZR_UNIQ_ID_STORAGE_KEY);
	if (typeof existing === 'string' && isDzrUniqId(existing)) {
		return existing;
	}

	const cookieValue = getCookieValue(DZR_UNIQ_ID_STORAGE_KEY);
	if (cookieValue && isDzrUniqId(cookieValue)) {
		storage.set(DZR_UNIQ_ID_STORAGE_KEY, cookieValue);
		return cookieValue;
	}

	const uniqId = generateUuidV4();
	storage.set(DZR_UNIQ_ID_STORAGE_KEY, uniqId);
	return uniqId;
};
